import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://kcoywdantbfcmdogsolo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtjb3l3ZGFudGJmY21kb2dzb2xvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAzMDEyMDQsImV4cCI6MjA4NTg3NzIwNH0.ih8u9DWbPB9dJj8GrggcFnUNBq5bf9XMLH9YKsfb6NI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);